import { SignalDoc, SignalType } from "@megaron/docs-contracts";

import { SignalDocumentGroup, groupSignals } from "./groupSignals";
import { isPersistentSignal, isSignalUnread } from "./persistentSignalTypes";

export { isPersistentSignal };

const isBadgeGroup = (group: SignalDocumentGroup, badgeSignalTypes: ReadonlySet<string>): boolean => {
  const badgeSignals = group.signals.filter((signal) => badgeSignalTypes.has(signal.signalType));
  if (badgeSignals.length === 0) return false;
  return badgeSignals.some(isSignalUnread);
};

export const navBadgeGroupCount = (
  signals: SignalDoc[],
  badgeSignalTypes: readonly SignalType[],
): number => {
  if (badgeSignalTypes.length === 0) return 0;

  const allowedTypes = new Set<string>(badgeSignalTypes);
  return groupSignals(signals).filter((group) => isBadgeGroup(group, allowedTypes)).length;
};

